const ItemTypes = {
    SLIDE: 'slide',
};

export default ItemTypes;



/** WEBPACK FOOTER **
 ** ./client/components/ItemTypes/ItemTypes.jsx
 **/